module.exports = __webpack_public_path__ + "img/gd10Logo.9cf8acc3.png";